import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "./translations";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "fr";
    const saved = localStorage.getItem("phaneroo:lang");
    if (saved === "fr" || saved === "en") return saved;
    const navLang = (navigator.language || "fr").toLowerCase();
    return navLang.startsWith("en") ? "en" : "fr";
  });

  useEffect(() => {
    localStorage.setItem("phaneroo:lang", lang);
    document.documentElement.lang = lang === "fr" ? "fr-CA" : "en-CA";
  }, [lang]);

  const t = useMemo(() => translations[lang] || translations.fr, [lang]);
  const toggle = () => setLang((l) => (l === "fr" ? "en" : "fr"));

  return (
    <I18nContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
